import React from 'react';
import FiverrLogo from '../../img/marketplace/fiverr-logo.png';
import UpworkLogo from '../../img/marketplace/upwork-logo.svg';
import FreelancerLogo from '../../img/marketplace/freelancer-logo.svg';
import PeoplePerHourLogo from '../../img/marketplace/peopleperhour-logo.png';

const MarketplaceSection = () => {
    return (
        <section className="marketplace" id="marketplace">
            <div className="container">
                <div className="text_center mbBig">
                    <h2 className="headingSecondary">I am Available for freelancing</h2>
                </div>

                <div className="marketplaceWrap">
                    <a href="https://www.fiverr.com/wasek23" target="_blank" rel="noopener noreferrer">
                        <div className="marketplaceBox">
                            <img src={FiverrLogo} alt="Fiverr" />
                        </div>
                    </a>
                    <a href="https://www.upwork.com/o/profiles/users/_~01774a60c9469db48a/" target="_blank" rel="noopener noreferrer">
                        <div className="marketplaceBox">
                            <img src={UpworkLogo} alt="Upwork" />
                        </div>
                    </a>
                    <a href="https://www.freelancer.com.bd/u/wasekbellah" target="_blank" rel="noopener noreferrer">
                        <div className="marketplaceBox">
                            <img src={FreelancerLogo} alt="Freelancer" />
                        </div>
                    </a>
                    <a href="http://pph.me/wasek23" target="_blank" rel="noopener noreferrer">
                        <div className="marketplaceBox">
                            <img src={PeoplePerHourLogo} alt="People Per Hour" />
                        </div>
                    </a>
                </div> {/* Marketplace Wrap */}
            </div> {/* Container */}
        </section> // Marketplace
    );
};

export default MarketplaceSection;